/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Audit_Details_Pattern_Enabled_NamedInputs */



/**
* | output |
* | --- |
* | "Pattern \"{name}\" is now active and monitoring requests" |
*
* @param {Audit_Details_Pattern_Enabled_NamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_pattern_enabled_named = /** @type {((inputs: Audit_Details_Pattern_Enabled_NamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Pattern_Enabled_NamedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Muster "${i?.name}" ist jetzt aktiv und überwacht Anfragen`)
	return /** @type {LocalizedString} */ (`Pattern "${i?.name}" is now active and monitoring requests`)
});